import React from 'react';
import { useTypedTranslation } from '@app/hooks';
import { TranslationsTypes } from '@app/models';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';

interface IProps {
    displayName: string;
    iconUrl: string;
    enabled: boolean;
    onToggle: () => void;
}

export const DeepLink = ({displayName, iconUrl, enabled, onToggle}: IProps) => {

    const { translation } = useTypedTranslation();

    return (
        <div className={`deep-link ${enabled ? 'deep-link--active' : ''}`} onClick={onToggle}>
            <div className='deep-link__icon'>
                <img className='deep-link__image' src={iconUrl ?? '/assets/images/apps/app-large.png'} alt={translation(displayName as TranslationsTypes)}/>
                {enabled && <CheckCircleIcon fontSize='small' className='deep-link__check' />}
            </div>
            <div className='deep-link__name'>{translation(displayName as TranslationsTypes)}</div>
        </div>
    );
};
